<template>
  <div id="paymentreminderpopup"  class="animated fadeIn">
    <b-modal  centered hide-footer id="paymentmethods" :no-close-on-backdrop="true" ref="paymentmethods">
          <slot name="modal-header">
            <div class="col-12 flex justify-end mt1">
              <button type="button" @click="hidemodal()"  class="h4 white-button no-border not-rounded gibson p0 m0 ">
                <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="17.633" height="17.632" viewBox="0 0 17.633 17.632">
                  <path id="Close" d="M-3642.184-128.272a8.815,8.815,0,0,1,8.816-8.816,8.815,8.815,0,0,1,8.817,8.816,8.815,8.815,0,0,1-8.817,8.816A8.815,8.815,0,0,1-3642.184-128.272Zm3.421-5.4a7.583,7.583,0,0,0-2.234,5.4,7.583,7.583,0,0,0,2.234,5.4,7.579,7.579,0,0,0,5.4,2.234,7.576,7.576,0,0,0,5.4-2.234,7.579,7.579,0,0,0,2.234-5.4,7.579,7.579,0,0,0-2.234-5.4,7.576,7.576,0,0,0-5.4-2.234A7.579,7.579,0,0,0-3638.763-133.668Zm2.2,8.588a.655.655,0,0,1,0-.958l2.233-2.234-2.233-2.234a.654.654,0,0,1,0-.958.648.648,0,0,1,.957,0l2.234,2.234,2.234-2.234a.681.681,0,0,1,.958,0,.682.682,0,0,1,0,.958l-2.234,2.234,2.234,2.234a.673.673,0,0,1,0,.958.681.681,0,0,1-.958,0l-2.234-2.234-2.234,2.234a.678.678,0,0,1-.48.2A.671.671,0,0,1-3636.559-125.08Z" transform="translate(3642.184 137.088)" fill="#499dbb"/>
                </svg>
                </span>
              </button>
            </div>
          </slot>
          <div class="flex col-12 m0 p0 flex-wrap " >
          <b-tabs vertical card class="col-12 p0 m0 darkblue ">
            
            <!-- <b-tab title="Betalingsmetode" > -->
              <div class=" clearfix white-background  m0 p0">
                <div class="flex flex-column gibson col-12 p0">
                  <div class="flex flex-column col-lg-10 col-md-10 col-sm-12 mx-auto">
                  <p class="h3 darkblue " >Hej {{partnername.replace('&\#039\;','\'')}}!</p>
                  <p class="h5 darkblue " >Betalingsmetoder</p>
                  </div>
                  <div class="col-10  mx-auto flex flex-column justify-around my2 p0">
                      
                      <button  v-b-toggle.reepay role="tablist" class="col-lg-8 col-md-8 col-sm-12 mx-auto p2 px2 gibson dark-button not-rounded flex justify-center items-center collapsed">
                        <span class="mx2 h5">Reepay</span>
                      </button>
                      <b-collapse id="reepay" visible accordion="my-accordion" role="tabpanel" class="col-lg-8 col-md-8 col-sm-12 mx-auto lightgrey-background">
                      <div id='rp_container' class="col-lg-8 col-md-8 col-sm-12 mx-auto p0 " style="height:462px"></div>
                      </b-collapse>
                      <button v-b-toggle.leveran  role="tablist" class="col-lg-8 col-md-8 col-sm-12 mx-auto p2 px2 gibson dark-button not-rounded flex justify-center items-center">
                            <span class="h5 mb0 mr2">Leverandørservice</span>
                            <span class="when-closed">
                              <span class="relative" style="top:3px;">
                                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                              </span>
                            </span>
                            <span class="flex-none when-opened">
                              <span class="relative" style="top:3px;">
                                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                              </span>
                            </span>
                      </button>
                      <b-collapse id="leveran" accordion="my-accordion" role="tabpanel" class="col-lg-8 col-md-8 col-sm-12 mx-auto lightgrey-background">
                            <div class="d-flex flex-row justify-content-start">
                            <div class="col-12 p0">

                              <b-alert show variant="success" class="my2" v-if="levandorupdate !== ''">
                                <h5 class="alert-heading">Tak! Din konto hos Leverandørservice er nu integreret med Håndværker.dk.
                                </h5>
                                <p>
                                </p>

                              </b-alert>
                              
                                <b-form class="py-2 p0" @submit.stop.prevent="service_levendor">
                                  <div class=" col-12 flex flex-wrap mt2 p0">
                                    <b-form-group id="nameInput" class="col-lg-6 col-md-6 col-sm-12" label="Din Bank" label-for="konto">
                                      <b-form-select v-model="bank" :options="options" required></b-form-select>
                                      <b-form-text id="password-help-block">
                                        Hvis din bank ikke er på listen, kan du ikke oprette forbindelse til leverandørservice
                                      </b-form-text>
                                    </b-form-group>
                                    <b-form-group id="nameInput" class="col-lg-6 col-md-6 col-sm-12" label="Registreringsnr." label-for="konto">
                                      <b-form-input id="konto" type="number" v-model="regnr" aria-describedby="input-live-help input-live-feedback" :formatter="limitbankregis" :state="regState" required placeholder="" size="4" :maxlength="4" class="bg-light rounded" autocomplete="off"></b-form-input>
                                      <b-form-text id="password-help-block">
                                        Indsæt venligst din Registreringsnr (4 kar)
                                      </b-form-text>
                                    </b-form-group>
                                    <b-form-group id="emailInput" class="col-lg-6 col-md-6 col-sm-12" label="Bankkonto" label-for="account">
                                      <b-form-input id="account" type="number" v-model="bankkonto" required placeholder="" :formatter="limitbankno" :state="bankState" class="bg-light rounded" size="10" maxlength="10" autocomplete="off"></b-form-input>
                                      <b-form-text id="password-help-block">
                                        Indsæt venligst din Bankkonto (10 kar)
                                      </b-form-text>
                                    </b-form-group>
                                    <b-form-group id="emailInput" class="col-lg-6 col-md-6 col-sm-12" label="CVR-nummer" label-for="cvr">
                                        <b-form-input id="cvr" type="number" v-model="cvr" required placeholder="" class="bg-light rounded" autocomplete="off" ></b-form-input>
                                    </b-form-group>
                                  </div>
                                  <div class="py-2"></div>
                                  <b-form-row>
                                    <b-col>
                                      <b-form-group label-for="consentInput" class="">
                                        <b-form-checkbox id="consentInput" v-model="consent" value="accepted" required unchecked-value="not_accepted">
                                          <span class="text-secondary open-sans">Jeg acceptere LeverandørService <a target="_blank" href="https://www.nets.eu/dk-da/SiteCollectionDocuments/leverandoerservice/LS_Regler_DB_debitor_regler_DK.pdf">reglerne</a></span>
                                        </b-form-checkbox>
                                      </b-form-group>
                                    </b-col>
                                  </b-form-row>
                                  <div class="py-2"></div>
                                  <b-row>
                                    <b-col v-if="levandorupdate === ''">
                                      <b-button type="submit" variant="success not-rounded flex col-lg-4 col-md-4 col-sm-12 justify-center items-center">
                                      <span class="mr2">
                                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevrons-circle-right-f"><path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm3.175-9.976l-2.122 2.121a1 1 0 0 0 1.414 1.414l2.829-2.828a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 1 0-1.414 1.415l2.122 2.12zm-4.99 0l-2.121 2.121a1 1 0 0 0 1.414 1.414l2.828-2.828a1 1 0 0 0 0-1.414L7.478 6.488a1 1 0 0 0-1.414 1.415l2.121 2.12z' /></svg>
                                      </span><span class="semi-bold h5 m0">Gem</span>
                                    </b-button></b-col>
                                    <b-col v-if="levandorupdate !== ''"> 
                                      <b-alert size="lg" show variant="secondary">
                                        <div class="flex flex-column">
                                        <div class="col-12"><span  class="el-icon-success text-success"></span> Sidste opdatering : {{ levandorupdate }}</div>
                                        <div class="col-12"><span  class="el-icon-success text-success"></span> Du kan opdaterer dine bankoplysninger 4 dage fra sidste gang du har gemt dem</div>
                                        </div>
                                      </b-alert>
                                    </b-col>
                                  </b-row>
                                  <div class="py-2"></div>
                                </b-form>
                              </div>
                            </div>
                      </b-collapse>
                      
                  </div>
                </div>
              </div>
              <div slot="modal-footer" class="col-12 p2 white-background" >
                <p>Hvis du har spørgsmål eller tror, ​​der er en fejl, så ring eller e-mail support.</p>
              </div>

            <!-- </b-tab> -->
            <!-- <b-tab title="Fakturaer" >Fakturaer
              
            </b-tab> -->
          
          </b-tabs>
          </div>
          <div slot="modal-footer" class="col-12 p2 white-background" >
            <p>Hvis du har spørgsmål eller tror, ​​der er en fejl, så ring eller e-mail support.</p>
          </div> 
    </b-modal>
    <b-modal  centered hide-footer  id="initialreminder" :no-close-on-backdrop="true" ref="initialreminder">
          <div class="py1" ></div>
        
          <div class="clearfix white-background col-12 ">
            <div class=" muted-border border shadow col-lg-8 col-md-8 col-sm-12 mx-auto my2 ">
                <slot name="modal-header">
                  <div class="col-12 flex justify-end my2">
                    <button type="button" @click="hidemodalinitial()"  class="h3 white-button no-border not-rounded gibson ">
                      <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="17.633" height="17.632" viewBox="0 0 17.633 17.632">
                        <path id="Close" d="M-3642.184-128.272a8.815,8.815,0,0,1,8.816-8.816,8.815,8.815,0,0,1,8.817,8.816,8.815,8.815,0,0,1-8.817,8.816A8.815,8.815,0,0,1-3642.184-128.272Zm3.421-5.4a7.583,7.583,0,0,0-2.234,5.4,7.583,7.583,0,0,0,2.234,5.4,7.579,7.579,0,0,0,5.4,2.234,7.576,7.576,0,0,0,5.4-2.234,7.579,7.579,0,0,0,2.234-5.4,7.579,7.579,0,0,0-2.234-5.4,7.576,7.576,0,0,0-5.4-2.234A7.579,7.579,0,0,0-3638.763-133.668Zm2.2,8.588a.655.655,0,0,1,0-.958l2.233-2.234-2.233-2.234a.654.654,0,0,1,0-.958.648.648,0,0,1,.957,0l2.234,2.234,2.234-2.234a.681.681,0,0,1,.958,0,.682.682,0,0,1,0,.958l-2.234,2.234,2.234,2.234a.673.673,0,0,1,0,.958.681.681,0,0,1-.958,0l-2.234-2.234-2.234,2.234a.678.678,0,0,1-.48.2A.671.671,0,0,1-3636.559-125.08Z" transform="translate(3642.184 137.088)" fill="#499dbb"/>
                      </svg>
                      </span>
                    </button>
                  </div>
                </slot>
              <div class="flex flex-column justify-start gibson col-12 p3">
                <p class="my2 darkblue">
                  <span clas="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="130" height="130" viewBox="0 0 116.96 92.339">
                      <path id="Path_5" data-name="Path 5" d="M12.879,79.46A43.971,43.971,0,0,1,43.971,4.4,43.477,43.477,0,0,1,64.058,9.244,44.327,44.327,0,0,1,79.3,22.183a2.633,2.633,0,0,1,2.429.222L85.919,25.1l4.062-2.311a2.637,2.637,0,0,1,3.941,2.292V69.358A2.637,2.637,0,0,1,89.9,71.6L85.884,69.12l-4.125,2.735a2.631,2.631,0,0,1-.845.367A43.976,43.976,0,0,1,12.879,79.46Zm3.729-58.455A38.694,38.694,0,1,0,71.33,75.728a39.161,39.161,0,0,0,4.711-5.689l-1.371-.89-4.03,2.7a2.641,2.641,0,0,1-2.884.035L63.45,69.149l-3.919,2.685A2.637,2.637,0,0,1,55.4,69.659V24.624a2.638,2.638,0,0,1,4.1-2.2l3.948,2.625,4.337-2.675a2.65,2.65,0,0,1,2.821.035l4.059,2.64,4.23-2.659-4.1,2.577a39.28,39.28,0,0,0-3.467-3.964,38.7,38.7,0,0,0-54.722,0ZM80.255,72.3a2.668,2.668,0,0,1-1.39-.424A2.644,2.644,0,0,0,80.255,72.3ZM64.809,63.761l4.325,2.748L73.176,63.8a2.641,2.641,0,0,1,2.906-.019l4.2,2.726,4.093-2.713a2.638,2.638,0,0,1,2.846-.044l1.425.88V29.617l-1.507.858a2.633,2.633,0,0,1-2.732-.073l-4.125-2.65-4.233,2.662a2.623,2.623,0,0,1-1.406.405,2.652,2.652,0,0,1-1.437-.424l-4.074-2.65L64.78,30.427a2.639,2.639,0,0,1-2.846-.047l-1.254-.836V64.65l1.222-.839a2.649,2.649,0,0,1,1.494-.462A2.616,2.616,0,0,1,64.809,63.761Zm-33.362-1.1a1.972,1.972,0,1,1,1.969,1.972A1.97,1.97,0,0,1,31.447,62.665Zm33.631-5.5a1.76,1.76,0,1,1,0-3.52H75.629a1.76,1.76,0,0,1,0,3.52ZM31.69,54.776l-1.232-19.72a2.959,2.959,0,0,1,5.917,0l-1.295,19.72c0,1.634-.8,2.219-1.665,2.219S31.69,56.409,31.69,54.776Zm42.182-6.408a1.759,1.759,0,1,1,1.757,1.757A1.758,1.758,0,0,1,73.872,48.368Zm-8.795,1.757a1.759,1.759,0,1,1,0-3.517h3.517a1.759,1.759,0,1,1,0,3.517Zm0-7.035a1.759,1.759,0,1,1,0-3.517H79.147a1.759,1.759,0,1,1,0,3.517ZM103.771,29.9a2.637,2.637,0,1,1,0-5.274h10.552a2.637,2.637,0,0,1,0,5.274ZM98.386,18.574a2.639,2.639,0,0,1,0-3.729L108.941,4.29a2.638,2.638,0,0,1,3.729,3.733L102.118,18.574a2.641,2.641,0,0,1-3.733,0ZM87.061,13.192V2.637a2.639,2.639,0,0,1,5.278,0V13.192a2.639,2.639,0,0,1-5.278,0Z" fill="#19a3c0"/>
                    </svg>
                  </span>
                </p>
                <p class="semi-bold h4 darkblue pt1 " >Hovsa! Din betaling til <a href="https://www.haandvaerker.dk" target="_blank" >Håndværker.dk</a> mislykkedes.</p>
                  <p class="h5 darkblue py1 " >Vi kunne ikke behandle din sidste betaling. Din konto forbliver aktiv, men opdater venligst dine kreditkortoplysninger for at undgå suspendering.</p>
                <button @click="showmodal(),hidemodalinitial(),showsessionnewcredit()" class=" mb2 mt3  py1 col-lg-4 col-md-4 col-sm-12 button green-background white no-border not-rounded gibson flex justify-center items-center">
                  <span class="mx2 my1">Opdater kreditkort</span>
                </button>
                <div class=" col-12 flex flex-wrap p0">
                  <p>Hvis du har spørgsmål eller tror, ​​der er en fejl, så
                  <a href="tel:+45#4570228014" class="no-underlined">ring</a>
                  eller
                  <a href="mailto:support@haandvaerker.dk" class="no-underlined ">e-mail</a>
                  support.</p>
                </div>
              </div>
            </div>
          </div>
          <div slot="modal-footer" class="col-12 p2 white-background" ><p>_</p>
          </div>
    </b-modal>
    <b-modal  centered hide-footer  id="sendingsuccess" :no-close-on-backdrop="true" ref="sendingsuccess">
          <div class="py1" ></div>
          <div class="clearfix white-background  m2">
            <div class="flex flex-column gibson col-12">
              <p class="my2 darkblue mx-auto " ><i class="el-icon-document-checked green" style="font-size:4em"></i></p>
              <p class="semi-bold h3 darkblue pt1 mx-auto" >Tak for din henvendelse,</p>
                <p class="h4 darkblue py1 mx-auto" >Vi ringer til dig hurtigst muligt</p>
              <button @click="hidemodaltak('')" class=" my2 col-lg-4 col-md-4 col-sm-12 button mx-auto darkblue-background white no-border not-rounded gibson flex justify-center items-center">
                <span class="mx2 my1">Luk</span>
              </button>
            </div>
          </div>
          <div slot="modal-footer" class="col-12 p2 white-background" ><p>_</p>
          </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'paymentreminderpopup',
  props: ['eligibilitydata'],
  data () {
    return {
      salesPerson: '',
      haaId: '',
      showreminder: '',
      partnername: '',
      hasleveran: '',
      regnr: '',
      bankkonto: '',
      help: '',
      cvr: '',
      bank: '',
      consent: '',
      levandorupdate: '',
      options: [],
      rp: '',
      showsessionnewcreditpro: '',
      shownewcreditpro: false,
      dunninginvoice: '',
      perndinginvoice: '',
      datamethod: '',
      leverandordate: ''
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.partnername = localStorage.getItem('CompanyName')
    // this.checkleveranpartner()
    // this.partnerinfo()
    // this.getpartnerinvoice()
    // this.getpartnerinvoicebystatus()
    // this.getpartnersubsciption()
  },
  computed: {
    regState () {
      return this.regnr.length === 4
    },
    bankState () {
      return this.bankkonto.length === 10
    }
  },
  methods: {
    showmodal () {
      this.$refs.paymentmethods.show()
    },
    showmodalinitial () {
      this.$refs.initialreminder.show()
    },
    hidemodal () {
      this.$refs.paymentmethods.hide()
    },
    hidemodalinitial () {
      this.$refs.initialreminder.hide()
    },
    hidemodalsuccess () {
      this.$refs.sendingsuccess.hide()
    },
    goto () {
      this.$router.push(this.partnerData['linkreferer'])
    },
    limitbankno (e) {
      return String(e).substring(0, 10)
    },
    limitbankregis (e) {
      return String(e).substring(0, 4)
    },
    checkleveranpartner () {
      var dataPartner = {operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, typeMeeting: '1'}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.cvr = res.cvr
            if (res.levandorupdate === '') {
              this.hasleveran = false
              this.levandorupdate = res.levandorupdate
            } else {
              this.hasleveran = true
            }
            if (this.haaId === '40035' || this.haaId === '10247') {
              this.hasleveran = false
              this.levandorupdate = ''
            }
            this.regnr = res.levandorregnr
            this.bankkonto = res.levandorbankkonto
            this.options = res.bankOptions
            this.leverandordate = res.levandorupdate
            this.getpartnerinvoicedue()
          },
          response => {
            alert('error')
          }
        )
    },
    processingperiod (a = '') {
      const datenow = new Date()
      const processingstart = new Date(a)
      const processingend = new Date(a)
      processingend.setDate(processingstart.getDate() + 5)
      if (datenow.getTime() >= processingstart.getTime() && datenow.getTime() <= processingend.getTime()) {
        return false
      } else {
        return true
      }
    },
    service_levendor () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'service_levendor', salesPerson: this.salesPerson, regnr: this.regnr, bankkonto: this.bankkonto, levid: this.haaId, cvr: this.cvr, bank: this.bank}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success'
              }
              this.$refs.simplert.openSimplert(obj)
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    partnerinfo () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/reepay/getPartnerInfo/' + this.haaId, {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.partnername = res.data.company
            this.dunninginvoice = res.data.dunning_invoices
            this.perndinginvoice = res.data.pending_invoices
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    getpartnerinvoice () {
      this.haaId = localStorage.getItem('haaid')
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/reepay/getPartnerInvoice/' + this.haaId, {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var checkinvoices = res.data.content
            var dunninginvoices = []
            var pendinginvoices = []
            dunninginvoices = checkinvoices.filter((item) => {
              return item.state === 'pending'
            })
            pendinginvoices = checkinvoices.filter((item) => {
              return item.state === 'dunning'
            })
            this.dunninginvoice = dunninginvoices.length
            this.perndinginvoice = pendinginvoices.length
            if (this.dunninginvoice > 0 || this.perndinginvoice > 0) {
              this.showreminder = 'true'
              this.$emit('Nopaymentmethod', this.showreminder)
            }
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    getpartnerinvoicedue () {
      if (this.check4hour()) {
        this.haaId = localStorage.getItem('haaid')
        var headers = {
          Authorization: 'Bearer ' + this.salesPerson
        }
        if (this.haaId === '40035' && (this.$bitrixapi === 'https://bitrixapidev.haandvaerker.dk/v1/' || this.$bitrixapi === 'https://bitrixapimaster.haandvaerker.dk/v1/')) {
          this.haaId = '140035'
        }
        this.$http.get(this.$bitrixapi + 'reepay/getPartnerInvoiceDue/' + this.haaId, {headers}, { emulateJSON: true }).then(
          (response) => {
            var res = response.body
            if (res.success) {
              var checkinvoices = res.data.content
              var dunninginvoices = []
              var pendinginvoices = []
              dunninginvoices = checkinvoices.filter((item) => {
                return item.state === 'dunning'
              })
              pendinginvoices = checkinvoices.filter((item) => {
                return item.state === 'pending'
              })
              this.dunninginvoice = dunninginvoices.length
              this.perndinginvoice = pendinginvoices.length
              if ((this.dunninginvoice >= 1 || this.perndinginvoice) && this.processingperiod(this.leverandordate)) {
                this.showreminder = 'true'
                this.$emit('Nopaymentmethod', this.showreminder)
              }
            }
          },
          (response) => {
            console.log('Error: ', response)
          }
        )
      }
    },
    getpartnerinvoicebystatus () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/reepay/getPartnerInvoice/' + this.haaId + '?status=dunning', {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            // console.log('getpartnerinvoicebystatus', res)
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    getpartnerpaymentmethod () {
      if (this.check4hour()) {
        var headers = {
          Authorization: 'Bearer ' + this.salesPerson
        }
        this.$http.get('https://bitrixapi.haandvaerker.dk/v1/reepay/getPartnerPaymentMethod/' + this.haaId, {headers}, { emulateJSON: true }).then(
          (response) => {
            var res = response.body
            if (res.success) {
              if (!this.hasleveran) {
                var cards = res.data.cards
                var activecards = []
                activecards = cards.filter((item) => {
                  return item.state === 'active'
                })
                if (activecards.length === 0) {
                  this.showreminder = 'true'
                  this.$emit('Nopaymentmethod', this.showreminder)
                }
              }
              if (this.dunninginvoice > 0 || (this.perndinginvoice > 0)) {
                this.showreminder = 'true'
                this.$emit('Nopaymentmethod', this.showreminder)
              }
            } else {
              console.log('something is wrong with getting payment card ')
            }
          },
          (response) => {
            console.log('Error: ', response)
          }
        )
      }
    },
    getpartnersubsciption () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/reepay/getPartnerSubsciption/' + this.haaId, {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            // console.log('getpartnersubsciption', res)
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    shownewcredit () {
      var data = {
        operation: 'newcredit',
        salesPerson: this.salesPerson
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.shownewcreditpro = true
          }
        )
    },
    showsessionnewcredit () {
      // var data = {
      //   operation: 'reepaysession',
      //   salesPerson: this.salesPerson,
      //   levid: this.haaId
      // }
      this.$http.post(this.$bitrixapi + 'reepay/recurringSession?partnerId=' + this.haaId, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              var data = res.data
              this.showsessionnewcreditpro = data.id
              this.showpopupreepay()
            } else {
              console.log('Error in showing session')
            }
          }
        )
    },
    showpopupreepay () {
      var m = this
      this.rp = new window.Reepay.EmbeddedCheckout(this.showsessionnewcreditpro, { html_element: 'rp_container', showReceipt: true })
      this.rp.addEventHandler(window.Reepay.Event.Accept, function (data) {
        m.datamethod = data.payment_method
        console.log('done adding card', data)
        setTimeout(() => {
          m.wait4hourreminder()
        }, 5000)
      })
    },
    destroyrd () {
      this.rp.destroy(this.showsessionnewcreditpro)
    },
    preloadrp () {
      this.rp = new window.Reepay.EmbeddedCheckout(null, { html_element: 'rp_container', showReceipt: true })
    },
    showrp () {
      this.rp.show(this.showsessionnewcreditpro, { html_element: 'rp_container', showReceipt: true })
    },
    wait4hourreminder () {
      const timenow = new Date()
      const timeafter4hour = new Date()
      timeafter4hour.setHours(timenow.getHours() + 4)
      localStorage.removeItem('timeaddedcard')
      localStorage.removeItem('timeaddedcardexpiry')
      localStorage.setItem('timeaddedcard', timenow)
      localStorage.setItem('timeaddedcardexpiry', timeafter4hour)
      this.$emit('Nopaymentmethod', 'false')
    },
    check4hour () {
      const timeaccessnow = new Date()
      var togettime = localStorage.getItem('timeaddedcard')
      var togettimeexpiry = localStorage.getItem('timeaddedcardexpiry')
      const togettimenew = new Date(togettime)
      const togettimeexpirynew = new Date(togettimeexpiry)
      if (togettime !== null && togettimeexpiry !== null) {
        if (timeaccessnow.getTime() > togettimenew.getTime() && timeaccessnow.getTime() < togettimeexpirynew.getTime()) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    }
  }
}
</script>
<style>
#paymentmethods___BV_modal_content_, #initialreminder___BV_modal_content_{
  max-width: 100%!important;
  margin: 0px;
  height: 100%!important;
}
#paymentmethods___BV_modal_body_ {
  padding: 0;
}
#initialreminder___BV_modal_body_ {
  padding: 0;
}

@media (min-width: 576px) {
  #initialreminder .modal-dialog {
      max-width: 100%!important;
      margin: 0px;
      padding: 0px;
      height: 100%!important;
  }
  #paymentmethods .modal-dialog {
      max-width: 100%!important;
      margin: 0px;
      padding: 0px;
      height: 100%!important;
  }
}
@media (max-width: 570px) {
  .rp-content-section-details-row{
    flex-direction: column;
  }
}
#paymentreminderpopup .collapsing {
  transition: transform 0.3s ease;
}
#paymentreminderpopup .switch-success > .switch-input:not(checked) ~ .switch-label {
  background: #CF000F;
  color: #fff;
  border: 0;
}
#paymentreminderpopup .switch-success > .switch-input:not(checked) ~ .switch-label::before {
  color: #fff!important;
}
#paymentreminderpopup .card-header {
    padding: 0;
    margin-bottom: 0;
    background-color: #fff;
    border-bottom: 1px solid #fff;
}
#paymentreminderpopup .nav-tabs .nav-link.active, .nav-tabs .navbar .active.dropdown-toggle, .navbar .nav-tabs .active.dropdown-toggle {
    /* color: #2c3e50; */
    background: #fff;
    border-color: #d1d4d7;
    border-left-color: #fff;
    border-right-color: #fff;

}
#paymentreminderpopup .nav-link:hover {
  background-color: lightgray;
}
#paymentreminderpopup .tab-content {
    margin-top: 0;
    background: #fff;
    border: 1px solid #e9edf0;
}
</style>



// WEBPACK FOOTER //
// paymentreminderpopup.vue?334e12d4